import { render, staticRenderFns } from "./GestionCostoTerrestre.vue?vue&type=template&id=48c33c36&scoped=true"
import script from "./GestionCostoTerrestre.vue?vue&type=script&lang=js"
export * from "./GestionCostoTerrestre.vue?vue&type=script&lang=js"
import style0 from "./GestionCostoTerrestre.vue?vue&type=style&index=0&id=48c33c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c33c36",
  null
  
)

export default component.exports